import { render, staticRenderFns } from "./LingueListComponent.vue?vue&type=template&id=ece063be"
import script from "./LingueListComponent.vue?vue&type=script&lang=js"
export * from "./LingueListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports